module.exports = __webpack_public_path__ + "static/img/index2.62660b22.png";